export default __webpack_public_path__ + "static/media/JinnyLovelace.6af1dc97.png";